import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from "@filadd/phi-plus-core";
import { NotificationListLoading } from "./NotificationListLoading";
export const NotificationListFallback = () => (_jsx(Popover.Content, { children: _jsx(NotificationListLoading, {}) }));
//# sourceMappingURL=NotificationListFallback.js.map